import { Metamodel } from 'app/model/base/model';
import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { SapBwCopySource } from 'app/model/pipeline/copysource/sap-bw.copysource';

export const sapBwMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.sapBw.linkedServiceType,
    displayName: stringResources.SapBW_DisplayText,
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-SapBW'
    },
    supportDatasetV2: true,
    isOnPremises: true,
    isFirstClass: true,
    copySinkTypes: [],
    onetimeQueryTemplate: 'SELECT\n\t[Measures].<<Measure>> as C1 ON ROWS, \n\tNON EMPTY <<Dimension>>.MEMBERS ON COLUMNS \nFROM <<Cube>>',
    timedQueryTemplate: 'SELECT\n\t[Measures].<<Measure>> as C1 ON ROWS, \n\tNON EMPTY <<Dimension>>.MEMBERS ON COLUMNS \nFROM <<Cube>>',
    copySourceTypes: [Metamodel.modelFor(SapBwCopySource).name],
    category: ['Database'],
    controls: [
        {
            type: 'textbox',
            bind: 'server',
            label: stringResources.ModelName_ServerName,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'systemNumber',
            label: stringResources.ModelName_SystemNumber,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'clientId',
            label: stringResources.ModelName_ClientId,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'userName',
            label: stringResources.ModelName_UserName,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'dynamic-akv-switcher',
            bind: 'password',
            label: stringResources.ModelName_Password,
            enableAKVParameterization: true,
            child: {
                type: 'password',
                label: stringResources.ModelName_Password,
                required: true,
                isLabelVertical: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.SapBW_DisplayText),
                stringResources.ModelName_Password)
        }
    ]
};
